import Checkbox from "../../../shared/checkbox/checkbox";
import {useDispatch} from "react-redux";
import {useState} from "react";

const AlertsFilter = ({filter, dispatcher}) => {
    const userAlerts = (JSON.parse(localStorage.getItem("user-details")))?.skuDetails?.alerts || [];
    const [searchedAlerts, setSearchedAlerts] = useState(userAlerts);
    const dispatch = useDispatch();

    const handleAlertSelect = (val) => {
        dispatch(dispatcher(val))
    }

    const handleSearch = (e) => {
        const searchTxt = (e.target.value).toLowerCase().trim();
        // reset on empty
        if (!searchTxt) {
            setSearchedAlerts([...userAlerts]);
        } else {
            const alerts = userAlerts.filter((alert) =>
                (alert?.alertShortString).toLowerCase().includes(searchTxt));
            setSearchedAlerts(alerts);
        }
    }

    return (
        <>
            <div className="filter-title">Alerts</div>
            <div className="search-box margin-b-30 round-corner-8">
                <input type="text" placeholder={'Search'} onChange={handleSearch}/>
            </div>

            <ul className="filter-sec">
                {searchedAlerts.map((alert) =>
                    <li className={`page-fade-in`} key={alert?.alertString}>
                        <div className="filter-box"
                             onClick={event => handleAlertSelect(alert?.alertString)}>
                            <Checkbox checked={filter?.alerts.includes(alert?.alertString)}/>
                            <div className={'filter-text'}>{alert?.alertShortString}</div>
                        </div>
                    </li>
                )}
            </ul>
        </>
    )
}

export default AlertsFilter;
